import React, { useState, useEffect } from 'react';
import './FeaturedProducts.css';

const FeaturedProducts = ({ onProductClick }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  const products = [
   {
      id: 1,
      name: 'Набір для догляду за волоссям',
      description: 'Інтенсивне відновлення пошкодженого волосся з кератином',
      fullDescription: 'Набір Monxuan для догляду за волоссям, підходить для всіх типів волосся, захищає колір волосся та забезпечує інтенсивне зволоження. Формули, збагачені рослинними екстрактами, перетворюють тонке та тьмяне волосся, повертаючи йому еластичність і блиск.',
    image: 'https://monxuan.ro/wp-content/uploads/2023/12/SamponMFamily-Medium.jpg',
 
      inStock: true,
      features: ['Відновлює структуру волосся', 'Насичує кератином', 'Без сульфатів', 'Для всіх типів волосся'],
      usage: 'Нанесіть невелику кількість на вологе волосся, збийте піну, ретельно змийте. Використовуйте разом з маскою для найкращого результату.'
    },
    {
      id: 2,
      name: 'Маска для дуже сухого та пошкодженого волосся, 260 мл ',
      description: 'Інтенсивне відновлення пошкодженого волосся з кератином',
      fullDescription: 'Відкрийте секрет здорового волосся з маскою Monxuan, унікальною формулою, яка відновлює та повертає красу волосся всього за 5-10 хвилин! Завдяки запатентованій технології формула маски для волосся Monxuan діє швидко, надаючи волоссю всі необхідні інгредієнти, щоб воно стало міцним, гладким та інтенсивно зволоженим. Маска для волосся Monxuan не містить агресивних хімічних речовин, і волосся повністю безпечне під час усього лікування. А отримані результати зберігаються надовго!',
      image: 'https://monxuan.ro/wp-content/uploads/2023/10/MaskM.jpg',
 
      inStock: true,
      features: ['Відновлює структуру волосся', 'Насичує кератином', 'Без сульфатів', 'Для всіх типів волосся'],
      usage: 'Нанесіть невелику кількість на вологе волосся, збийте піну, ретельно змийте. Використовуйте разом з маскою для найкращого результату.'
    },
    {
      id: 3,
      name: 'Шампунь для пошкодженого волосся, 380 мл',
      description: 'Інтенсивне відновлення пошкодженого волосся з кератином',
      fullDescription: 'Відкрийте секрет ідеального волосся з шампунем Monxuan, унікальною формулою, що відновлює та повертає здоровя пошкодженим волоссям без використання агресивних хімічних речовин, даруючи вашому волоссю справжнє та тривале перетворення.',
      image: 'https://monxuan.ro/wp-content/uploads/2023/10/SamponM.jpg',
 
      inStock: true,
      features: ['Відновлює структуру волосся', 'Насичує кератином', 'Без сульфатів', 'Для всіх типів волосся'],
      usage: 'Нанесіть невелику кількість на вологе волосся, збийте піну, ретельно змийте. Використовуйте разом з маскою для найкращого результату.'
    },
    {
      id: 4,
      name: 'Спрей для пошкодженого волосся leave-in Monxuan, 200 мл',
      description: 'Інтенсивне відновлення пошкодженого волосся з кератином',
      fullDescription: '– Підходить для всіх типів волосся –MONXUAN Elixir – інтенсивний зволожуючий догляд для волосся, який миттєво перетворює тьмяне, сухе та зневоднене волосся на шовк.– Підходить для всіх типів волосся –',
      image: 'https://monxuan.ro/wp-content/uploads/2023/10/maasca-pentru-par.jpg',
 
      inStock: true,
      features: ['Відновлює структуру волосся', 'Насичує кератином', 'Без сульфатів', 'Для всіх типів волосся'],
      usage: 'Нанесіть невелику кількість на вологе волосся, збийте піну, ретельно змийте. Використовуйте разом з маскою для найкращого результату.'
    },
    {
      id: 5,
      name: 'Шампунь для пошкодженого волосся, 720 мл',
      description: 'Інтенсивне відновлення пошкодженого волосся з кератином',
      fullDescription: 'Цей шампунь інтенсивно відновлює пошкоджене волосся завдяки унікальній формулі з кератином, біотином та натуральними оліями. Відновлює структуру волосся, заповнюючи пошкодження, надає волоссю здорового блиску та міцності. Ідеально підходить для фарбованого та ослабленого волосся.',
      image: 'https://monxuan.ro/wp-content/uploads/2025/02/HairSingle.jpg',
 
      inStock: true,
      features: ['Відновлює структуру волосся', 'Насичує кератином', 'Без сульфатів', 'Для всіх типів волосся'],
      usage: 'Нанесіть невелику кількість на вологе волосся, збийте піну, ретельно змийте. Використовуйте разом з маскою для найкращого результату.'
    },
    {
      id: 6,
      name: 'Набір для догляду за волоссям Monxuan L',
      description: 'Інтенсивне відновлення пошкодженого волосся з кератином',
      fullDescription: 'Набір для догляду за волоссям Monxuan, підходить для всіх типів волосся, захищає колір волосся та надає йому інтенсивне зволоження. Формули, збагачені рослинними екстрактами, перетворюють тонке та тьмяне волосся, повертаючи йому еластичність і блиск',
      image: 'https://monxuan.ro/wp-content/uploads/2025/05/21-1.jpg',
 
      inStock: true,
      features: ['Відновлює структуру волосся', 'Насичує кератином', 'Без сульфатів', 'Для всіх типів волосся'],
      usage: 'Нанесіть невелику кількість на вологе волосся, збийте піну, ретельно змийте. Використовуйте разом з маскою для найкращого результату.'
    },
    {
      id: 7,
      name: 'Маска для дуже сухого та пошкодженого волосся, 720 мл',
      description: 'Інтенсивне відновлення пошкодженого волосся з кератином',
      image: 'https://monxuan.ro/wp-content/uploads/2025/02/Balsamsingle.jpg',
 
      inStock: true,
      features: ['Відновлює структуру волосся', 'Насичує кератином', 'Без сульфатів', 'Для всіх типів волосся'],
      usage: 'Нанесіть невелику кількість на вологе волосся, збийте піну, ретельно змийте. Використовуйте разом з маскою для найкращого результату.'
    },
  ];

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === products.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? products.length - 1 : prevIndex - 1
    );
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  // Автоматическая прокрутка
  useEffect(() => {
    if (!isAutoPlaying) return;

    const interval = setInterval(() => {
      nextSlide();
    }, 5000);

    return () => clearInterval(interval);
  }, [currentIndex, isAutoPlaying]);

  const getDiscountPercent = (price, originalPrice) => {
    return Math.round(((originalPrice - price) / originalPrice) * 100);
  };

  return (
    <section className="featured-products" id="featured">
      <div className="container">
        <h2 className="section-title">Популярні Товари</h2>
        <p className="section-subtitle">
          Найпопулярніші продукти, які обирають наші клієнти
        </p>

        <div 
          className="carousel-container"
          onMouseEnter={() => setIsAutoPlaying(false)}
          onMouseLeave={() => setIsAutoPlaying(true)}
        >
          <div className="carousel">
            <button className="carousel-button prev" onClick={prevSlide}>
              ‹
            </button>

            <div className="carousel-track-container">
              <div 
                className="carousel-track"
                style={{ transform: `translateX(-${currentIndex * 100}%)` }}
              >
                {products.map((product, index) => (
                  <div 
                    key={product.id} 
                    className={`carousel-slide ${index === currentIndex ? 'active' : ''}`}
                  >
                    <div 
                      className="product-card"
                      onClick={() => onProductClick(product)}
                    >
                      {product.badge && (
                        <span className="product-badge">{product.badge}</span>
                      )}
                      <div className="product-image-container">
                        <img 
                          src={product.image} 
                          alt={product.name}
                          className="product-image"
                        />
                      </div>
                      <div className="product-info">
                        <h3 className="product-title">{product.name}</h3>
                        <p className="product-description">{product.description}</p>
                        <div className="product-price">
                          {product.originalPrice > product.price ? (
                            <>
                              <span className="current-price">{product.price} </span>
                              <span className="original-price">{product.originalPrice} </span>
                              <span className="discount-percent">
                                -{getDiscountPercent(product.price, product.originalPrice)}%
                              </span>
                            </>
                          ) : (
                            <span className="current-price">{product.price} </span>
                          )}
                        </div>
                        <div className="product-view-btn">
                          Детальніше →
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <button className="carousel-button next" onClick={nextSlide}>
              ›
            </button>
          </div>

          {/* Индикаторы */}
          <div className="carousel-indicators">
            {products.map((_, index) => (
              <button
                key={index}
                className={`indicator ${index === currentIndex ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProducts;